import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useSubscribe } from '@/js/libs/observable';
import { OnHover } from '../../Components/OnHover';
import { Tooltip } from '../../Feedback/Tooltip';
import Icons from '../Icons';
import { IconWrapper, Animation } from './styled';
export const UnavailableIcon = ({ tooltip, onClick, pending$, }) => {
    const theme = useTheme();
    const pending = useSubscribe((ctx) => (pending$ ? ctx.spy(pending$) : false));
    return (_jsx(Tooltip, { tooltip: tooltip, placement: 'top', children: _jsx(IconWrapper, { children: pending ? (_jsx(Animation, { children: _jsx(Icons.Spinner, { color: theme.colors.link70 }) })) : (_jsx(OnHover, { children: (hovered) => _jsx(Icons.TemporaryUnavailable, { filled: hovered, size: 24, color: theme.colors.link70, onClick: onClick }) })) }) }));
};
